
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M38.52 33.37L21.36 16.2A63.6 63.6 0 0159.5.16v24.3a39.5 39.5 0 00-20.98 8.92z","fill":"#000000"}}),_c('path',{attrs:{"d":"M67.642 24.324L67.649.05a63.6 63.6 0 0138.31 15.627L88.778 32.86a39.5 39.5 0 00-21.142-8.528zM94.63 38.52l17.17-17.16a63.6 63.6 0 0116.04 38.14h-24.3a39.5 39.5 0 00-8.92-20.98zM103.676 67.642l24.275.007a63.6 63.6 0 01-15.627 38.31L95.14 88.778a39.5 39.5 0 008.528-21.142zM89.48 94.63l17.16 17.17a63.6 63.6 0 01-38.14 16.04v-24.3a39.5 39.5 0 0020.98-8.92zM60.358 103.676l-.007 24.275a63.6 63.6 0 01-38.31-15.627L39.222 95.14a39.5 39.5 0 0021.142 8.528zM33.37 89.48L16.2 106.64A63.6 63.6 0 01.16 68.5h24.3a39.5 39.5 0 008.92 20.98zM24.324 60.358L.05 60.351a63.6 63.6 0 0115.627-38.31L32.86 39.222a39.5 39.5 0 00-8.528 21.142z","fill":"#c0c0c0","fill-opacity":".25"}}),_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"0 64 64;45 64 64;90 64 64;135 64 64;180 64 64;225 64 64;270 64 64;315 64 64","calcMode":"discrete","dur":"720ms","repeatCount":"indefinite"}})])])
          )
        }
      }
    